import React, { useContext } from "react";
import styled from "styled-components";
import DATA from "../const/data";
import { MainContext } from "../context/MainContext";
import { isUserCompletedProfile } from "../utils";
import Ad from "../components/Ad";
import AdSocialBar from "../components/AdSocialBar";
import ProfileMessages from "../components/ProfileMessages";
import Results from "../components/Results";
import SearchPanel from "../components/SearchPanel";

const Intro = styled.section`
    max-width: 760px;
    margin-bottom: 22px;

    .eyebrow {
        margin: 0 0 10px;
        color: var(--muted);
        font-size: 11px;
        font-weight: 750;
        letter-spacing: 0.18em;
        text-transform: uppercase;
    }

    h1 {
        margin: 0;
        color: var(--text);
        font-family: Georgia, "Times New Roman", serif;
        font-size: clamp(38px, 11vw, 68px);
        line-height: 0.98;
        letter-spacing: -0.055em;

        span { color: var(--accent); }
    }

    p {
        max-width: 600px;
        margin: 16px 0 0;
        color: var(--text-soft);
        font-size: clamp(15px, 4.2vw, 18px);
    }

    @media (min-width: 768px) {
        margin-bottom: 32px;
    }

    @media (max-width: 480px) {
        margin-bottom: 16px;

        .eyebrow { margin-bottom: 7px; }
        p:not(.eyebrow) { margin-top: 10px; font-size: 14px; line-height: 1.4; }
    }
`;

const AdSection = styled.aside`
    margin: 48px auto 0;
    padding-top: 32px;
    border-top: 1px solid var(--line);
    text-align: center;
`;

const MainPage = () => {
    document.title = `Search${ DATA.websiteTitle }`;
    const { userContext, searchedContext } = useContext(MainContext);
    const [user] = userContext;
    const [searched] = searchedContext;

    return (
        <>
            <Intro>
                <p className="eyebrow">Real people. Real conversations.</p>
                <h1>Find your <span>match</span></h1>
                <p>Choose who you would like to meet and start a conversation on Telegram.</p>
            </Intro>

            { !isUserCompletedProfile(user) && <ProfileMessages/> }
            <SearchPanel/>
            { searched && <Results/> }

            <AdSection aria-label="Sponsored content">
                <Ad/>
                <AdSocialBar/>
            </AdSection>
        </>
    );
};

export default MainPage;
